import { endpoints } from "config/endpoints.config"
import { generic, GenericResource, IGenericModel } from "models/generic"

export interface VoipSettings {
  enableRecording: boolean
  enableTranscribing: boolean
}

export enum VoipCallStatus {
  RINGING = "ringing",
  ANSWERED = "answered",
  FAILED = "failed",
  NO_ANSWER = "no_answer",
  ENDED_BY_OPERATOR = "ended_by_operator",
  ENDED_BY_CONTACT = "ended_by_contact",
  ENDED = "ended",
}

export enum VoipCallInitedBy {
  OPERATOR = "operator",
  CONTACT = "contact",
}

export interface IVoipCall extends GenericResource {
  conversationId: string
  channelId: string
  operatorId: string
  messageId: string
  referenceId: string
  callId: string
  contactId: string
  destination: string // phone
  minutes: number
  finishedAt: string
  answeredAt: string
  status: VoipCallStatus
  initedBy: VoipCallInitedBy
  recordUrl: string
  transcript: {
    segments: {
      speaker: string
      text: string
      start: number
      end: number
    }[]
    summary: string
    who_is_a: "operator" | "customer"
    sentiment: "positive" | "negative" | "neutral"
  }
  extra: Record<string, any>
}

export const voipCalls: IGenericModel<IVoipCall> = {
  ...generic(endpoints.VOIP_CALLS),
}
